import fa from '@fortawesome/fontawesome'
import faSolid from '@fortawesome/fontawesome-free-solid'

import customIcons from './custom-icons'

fa.library.add(faSolid, ...customIcons)



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/index.js